import { render, staticRenderFns } from "./PermitApplication.vue?vue&type=template&id=3c2c3216&"
import script from "./PermitApplication.vue?vue&type=script&lang=js&"
export * from "./PermitApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports